import { describeFilter } from 'components/dynamic-content/copy-util';
import { CityPageCityFragment, CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

const generateFilterDescription = (activeFilter?: CityPageFilterFragment): string | null => {
  const { filterDescription, hasFoodOrGoods } = describeFilter(activeFilter);
  return hasFoodOrGoods ? filterDescription : `${filterDescription} Food`;
};

export const generateCityPageTitle = (
  cityPage: Pick<CityPageCityFragment, 'cityName' | 'stateNameShort'>,
  activeFilter?: CityPageFilterFragment
): string => {
  const cityStateName = `${cityPage.cityName}, ${cityPage.stateNameShort}`;
  if (activeFilter) {
    const filterDescription = generateFilterDescription(activeFilter);
    return `Find Homemade ${filterDescription} Delivered in ${cityStateName}`;
  }
  return `Homemade Food in ${cityStateName} Delivered Fresh!`;
};

export const generateZipPageTitle = (
  zipCode,
  cityPage: Pick<CityPageCityFragment, 'cityName' | 'stateNameShort'>,
  activeFilter?: CityPageFilterFragment
): string => {
  const cityStateName = `${cityPage.cityName}, ${cityPage.stateNameShort}`;
  if (activeFilter) {
    const filterDescription = generateFilterDescription(activeFilter);
    return `Homemade ${filterDescription} in ${zipCode} Delivered | ${cityStateName}`;
  }
  return `Homemade Food Delivered in ${zipCode}`;
};
